<template>
<section class="trainer">
  <div class="trainer__header">
    <div class="game__info train__info">
      <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
        <div class="train__ico train__ico--4"></div>
        <small>Выполнено:</small>
        <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
      </div>

      <div class="train__item next-number" uk-tooltip="Следующее число">
        <div class="train__ico train__ico--1"></div>
        <small>Следующее:</small>
        {{ getNextCif }}
      </div>

      <div class="train__item" uk-tooltip="Ошибок">
        <div class="train__ico train__ico--2"></div>
        <small>Ошибок:</small>
        {{ errors }}
      </div>
      <div class="train__item" uk-tooltip="Времени прошло">
        <div class="train__ico train__ico--3"></div>
        <div>
          <small>Времени прошло:</small>
          <Timer ref="timer" @stop="showResult($event, false)" />
        </div>
      </div>
    </div>
    <a class="trainer__stop-btn" href="#" @click.prevent="stop">Остановить</a>
  </div>

  <div class="trainer__body">
    <div class="shulte__table" :class="(params.size % 2 == 0) ? 'even' : 'odd'" :style="'grid-template: repeat(' + params.size + ', 1fr) / repeat(' + params.size + ', 1fr);'">
      <div class="shulte__item" v-for="i in shuffle" :key="i.id" @click="checkNumber($event, i)"><span :style="`transform: rotate(${params.rotate}deg)`">{{ i }}</span></div>
    </div>
  </div>
</section>
</template>

<script>
import Timer from '../../../../other/Timer.vue'
export default {
  name: "game",
  inject: ['http'],
  props: ['params'],
  components: { Timer },
  data() {
    return {
      gameParams: null,
      cifs: '',
      shuffle: '',
      step: 0,
      errors: 0,
      letters: [
        'А',
        'Б',
        'В',
        'Г',
        'Д',
        'Е',
        'Ё',
        'Ж',
        'З',
        'И',
        'Й',
        'К',
        'Л',
        'М',
        'Н',
        'О',
        'П',
        'Р',
        'С',
        'Т',
        'У',
        'Ф',
        'Х',
        'Ц',
        'Ч',
        'Ш',
        'Щ',
        'Ъ',
        'Ы',
        'Ь',
        'Э',
        'Ю',
        'Я',
      ],
    }
  },
  computed: {
    getNextCif() {
      return this.cifs[this.step];
    }
  },
  methods: {
    shuffleArray(arr) {
      let j, temp;
      for (let i = arr.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        temp = arr[j];
        arr[j] = arr[i];
        arr[i] = temp;
      }
      return arr;
    },
    stop() {
      this.$emit('stop')
      if (this.$route.params.isHomework) {
        this.$router.go(-1)
      }
    },
    nexStep() {
      this.step++;

      

      if (this.step === this.cifs.length) {
        this.showResult(this.$refs.timer.elapsedTimeData)
      }      
    },
    showResult(elapsed) {
      let data = {
        elapsedTime: elapsed,
        errors: this.errors,
        isSuccess: true
      }

      this.$emit('show-result', data)      
    },
    checkNumber(event, i) {
      let el = event.target;
      let next = this.getNextCif;

      if (i == next) {
        el.classList.add("pass");
        el.classList.add("success");

        setTimeout(() => {
          el.classList.remove("success")

          if (this.gameParams.shuffle) {            
            this.shuffle = this.shuffleArray(this.shuffle.slice())
          } 
        }, 400);

        this.nexStep();
      } else {
        el.classList.add("error");
        setTimeout(function () {
          el.classList.remove("error");
        }, 400);
        this.errors++;
      }      
    },
    init() {
      let cifs = [];
      let size = this.gameParams.size;
      let qnt = size * size + 1;
      if (this.gameParams.mode === 'digits') {
        cifs = this.makeDigitsArray(qnt);
      } else if (this.gameParams.mode === 'letters') {
        if (this.gameParams.size > 5) {
          this.gameParams.size = 5;
          qnt = 26;
        }
        cifs = this.makeLettersArray(qnt);
      }
      this.cifs = cifs;
      this.shuffle = this.shuffleArray(cifs.slice());
    },
    makeDigitsArray(qnt) {
      let cifs = Array.from(Array(qnt).keys())

      cifs.splice(0, 1)

      if (this.gameParams.direction === 'reverse') {
        cifs.reverse()
      }

      if (this.gameParams.direction === 'random') {
        cifs = this.shuffleArray(cifs)
      }

      return cifs;
    },
    makeLettersArray(qnt) {
      let cifs = [];
      let letters = this.letters.slice();
      if (this.gameParams.direction === 'direct') {
        for (let i = 1; i < qnt; i++) {
          cifs.push(letters[i - 1]);
        }
      } else if (this.gameParams.direction === 'reverse') {
        for (let i = qnt - 1; i > 0; i--) {
          cifs.push(letters[i - 1]);
        }
      } else if (this.gameParams.direction === 'random') {
        let attempts = qnt
        for (let i = 1; i < attempts; i++) {
          let rand = Math.round(0.5 + Math.random() * letters.length - 1);

          if (cifs.includes(letters[rand])) {
            attempts++
          } else {
            cifs.push(letters[rand])
          }
        }
      }

      return cifs;
    },
    startGame() {
      this.$refs.timer.start()
      this.init();
    }
  },
  mounted() {
    this.gameParams = Object.assign({}, this.params)
    this.startGame()
  }
}
</script>

<style lang="scss" scoped>
.next-number {
  font-size: 20px;
}
</style>
